import { render } from "./StoreInformations.vue?vue&type=template&id=6f1e78c9&scoped=true"
import script from "./StoreInformations.vue?vue&type=script&lang=ts"
export * from "./StoreInformations.vue?vue&type=script&lang=ts"

import "./StoreInformations.vue?vue&type=style&index=0&id=6f1e78c9&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6f1e78c9"

export default script